import { FormLabel, FormLabelProps, Typography } from '@mui/material';

import { RequiredAsterisk } from '../RequiredAsterisk';

export const Label = ({
  children,
  htmlFor,
  required,
  ...props
}: FormLabelProps & { required?: boolean }) => {
  const styles = {
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: 1.2,
    color: 'custom.inputLabel',
    '@media (max-width: 960px) and (min-width: 768px)': {
      width: '600px',
    },
    '&.Mui-focused': {
      color: 'custom.inputLabel',
    },
  };

  if (htmlFor) {
    return (
      <FormLabel htmlFor={htmlFor} sx={styles} {...props}>
        {children}
        {required && <RequiredAsterisk />}
      </FormLabel>
    );
  }

  return (
    <Typography sx={styles}>
      {children}
      {required && <RequiredAsterisk />}
    </Typography>
  );
};
